<template>
  <div v-if="invoice" class="main-content invoice-view-page">
    <div class="page-header">
      <h3 class="page-title"> {{ invoice.reference_number }}</h3>
      <div class="page-actions row">
        <a :href="`/invoices/export/${invoice.unique_hash}`" target="_blank" class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size" color="theme">
          {{ $t('general.export_invoice') }}
        </a>
        <base-button
          v-if="invoice.status === 'DRAFT' && userType=='supplier'"
          :loading="isSendingEmail"
          :disabled="isSendingEmail"
          color="theme"
          @click="onSendInvoice"
        >
          {{ $t('invoices.send_invoice') }}
        </base-button>
        <!--supplier pay button-->
        <router-link v-if="userType=='supplier' && invoice.request_level=='Not Eligible' && invoice.paid_status!='PAID' && invoice.pre_pay==0 && (invoice.status === 'SENT' || invoice.status === 'VIEWED' || invoice.status === 'OVERDUE')"
                     :to="`/supplier/payments/${invoice.id}/payment/create`">
          <base-button color="theme">{{ $t('payments.record_payment') }} </base-button>
        </router-link>

        <!--anchor pay button-->
        <router-link v-if="userType=='anchor' && (invoice.paid_status==='UNPAID' ||invoice.paid_status=='PARTIALLY_PAID') && (invoice.status === 'SENT' || invoice.status === 'VIEWED' || invoice.status === 'OVERDUE') && invoice.pre_pay==1 && (invoice.request_level=='Eligible' || invoice.request_level=='Rejected' || invoice.request_level=='Prepaid')"
                     :to="`/anchor/payments/${invoice.id}/create`">
          <base-button color="theme"> {{ $t('payments.record_payment') }} </base-button>
        </router-link>

        <!--funder prepay button-->
        <router-link v-if="userType=='funder' && invoice.request_level=='Financed' && invoice.prepayment ==null"
                     :to="`/funder/payments/${invoice.id}/prepayment/create`">
          <base-button color="theme"> {{ $t('invoices.make_prepayment') }} </base-button>
        </router-link>

        <!--supplier settlement button-->
        <router-link v-if="userType==='supplier' && (invoice.payment_receiver && invoice.payment_receiver.account.account_type=='supplier')
                       && invoice.request_level=='Prepaid' && invoice.overall_status=='PAID'
                     && invoice.paid_status=='PAID' && invoice.pre_pay==1 && invoice.status === 'SENT' "
                     :to="`/supplier/payments/${invoice.id}/settlement/create`">
          <base-button color="theme"> {{ $t('general.need_settlement') }}  </base-button>
        </router-link>

        <!--funder settlement button-->
        <router-link v-if=" userType==='funder' && (invoice.payment_receiver && invoice.payment_receiver.account.account_type=='funder')
        && invoice.request_level=='Prepaid' && invoice.overall_status=='PAID' && invoice.paid_status=='PAID' && invoice.pre_pay==1 && invoice.status === 'SENT' ">
          <base-button color="theme"> {{ $t('general.need_settlement') }}  </base-button>
        </router-link>

        <v-dropdown v-if="invoice.status == 'DRAFT' && userType=='supplier'" :close-on-select="false" align="left" class="filter-container">
          <a slot="activator" href="#">
            <base-button color="theme">
              <font-awesome-icon icon="ellipsis-h" />
            </base-button>
          </a>
          <v-dropdown-item>
            <router-link :to="{path: `/supplier/invoices/${$route.params.id}/edit`}" class="dropdown-item">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon"/>
              {{ $t('general.edit') }}
            </router-link>
            <div class="dropdown-item" @click="removeInvoice($route.params.id)">
              <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
              {{ $t('general.delete') }}
            </div>
          </v-dropdown-item>
        </v-dropdown>
      </div>
    </div>
    <div class="invoice-sidebar">
      <div class="side-header">
        <base-input
          v-model="searchData.searchText"
          :placeholder="$t('general.search')"
          input-class="inv-search"
          icon="search"
          type="text"
          align-icon="right"
          @input="onSearch"
        />
        <div
          class="btn-group ml-3"
          role="group"
          aria-label="First group"
        >
          <v-dropdown :close-on-select="false" align="left" class="filter-container">
            <a slot="activator" href="#">
              <base-button class="inv-button inv-filter-fields-btn" color="default" size="medium">
                <font-awesome-icon icon="filter" />
              </base-button>
            </a>
            <div class="filter-title">
              {{ $t('general.sort_by') }}
            </div>
            <div class="filter-items">
              <input
                id="filter_invoice_date"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="inv-radio"
                value="invoice_date"
                @change="onSearch"
              >
              <label class="inv-label" for="filter_invoice_date">{{ $t('invoices.invoice_date') }}</label>
            </div>
            <div class="filter-items">
              <input
                id="filter_due_date"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="inv-radio"
                value="due_date"
                @change="onSearch"
              >
              <label class="inv-label" for="filter_due_date">{{ $t('invoices.due_date') }}</label>
            </div>
            <div class="filter-items">
              <input
                id="filter_invoice_number"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="inv-radio"
                value="invoice_number"
                @change="onSearch"
              >
              <label class="inv-label" for="filter_invoice_number">{{ $t('invoices.invoice_number') }}</label>
            </div>
          </v-dropdown>
          <base-button v-tooltip.top-center="{ content: getOrderName }" class="inv-button inv-filter-sorting-btn" color="default" size="medium" @click="sortData">
            <font-awesome-icon v-if="getOrderBy" icon="sort-amount-up" />
            <font-awesome-icon v-else icon="sort-amount-down" />
          </base-button>
        </div>
      </div>
      <base-loader v-if="isSearching" />
      <div v-else class="side-content">
        <a v-for="(invoice,index) in invoices"
           :key="index"
           href="#/"
           class="side-invoice"
           @click="viewInvoice(invoice.id)"
        >
          <div class="left">
            <div v-if="(userType=='supplier' || userType=='funder' || userType=='super_admin')" class="inv-name">
              <p v-if="invoice.buyer_stakeholder">
                <span v-if="invoice.buyer_stakeholder.details.company && invoice.customer.parent_account_id && invoice.buyer_stakeholder.details.company.name">
                  {{ invoice.buyer_stakeholder.details.company.name }}
                </span>
                <span v-else-if="invoice.buyer_stakeholder.details.company && invoice.customer.parent_account_id == null&& invoice.buyer_stakeholder.details.company.name">
                  {{ invoice.buyer_stakeholder.details.user.name }}
                </span>
                <!-- {{ invoice.buyer_stakeholder.details.user.name }} -->
              </p>
            </div>
            <div v-else-if="userType =='anchor'" class="inv-name">
              <p v-if="invoice.supplier_stakeholder">
                <span v-if="invoice.supplier_stakeholder.details.company && invoice.supplier_stakeholder.details.company.name">
                  {{ invoice.supplier_stakeholder.details.company.name }}
                </span>
                <!-- {{ invoice.supplier_stakeholder.details.user.name }} -->
              </p>
            </div>
            <div class="inv-number">{{ invoice.reference_number }}</div>
            <div :class="'inv-status-'+invoice.status.toLowerCase()" class="inv-status">{{ invoice.status }}</div>
          </div>
          <div class="right">
            <div class="inv-amount" v-html="$utils.formatMoney(invoice.nominal_amount, invoice.customer.currency)"/>
            <div class="inv-date">{{ invoice.formattedInvoiceDate }}</div>
          </div>
        </a>
        <p v-if="!invoices.length" class="no-result">
          {{ $t('invoices.no_matching_invoices') }}
        </p>
      </div>
    </div>
    <div class="invoice-view-page-container" >
      <iframe :src="`${shareableLink}`" class="frame-style"/>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const _ = require('lodash')
export default {
  data () {
    return {
      advanceOption: true,
      id: null,
      count: null,
      invoices: [],
      invoice: null,
      currency: null,
      searchData: {
        orderBy: null,
        orderByField: null,
        searchText: null
      },
      isRequestOnGoing: false,
      isSearching: false,
      isSendingEmail: false,
      isMarkingAsSent: false,
      userType: null
    }
  },
  computed: {
    getOrderBy () {
      if (this.searchData.orderBy === 'asc' || this.searchData.orderBy == null) {
        return true
      }
      return false
    },
    getOrderName () {
      if (this.getOrderBy) {
        return this.$t('general.ascending')
      }
      return this.$t('general.descending')
    },
    shareableLink () {
      return `/invoices/pdf/${this.invoice.unique_hash}`
    }
  },
  watch: {
    $route (to, from) {
      this.loadInvoice()
    }
  },
  created () {
    if (localStorage.getItem('role') == 'super_admin' || localStorage.getItem('account_type') == 'anchor' || localStorage.getItem('account_type') == 'funder') {
      this.advanceOption = false
    } else {
      this.advanceOption = true
    }
    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') == 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') == 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') == 'supplier') {
      this.userType = 'supplier'
    }

    this.loadInvoices()
    this.loadInvoice()
    this.onSearch = _.debounce(this.onSearch, 500)
  },
  methods: {
    ...mapActions('invoice', [
      'fetchAllInvoices',
      'fetchInvoices',
      'getRecord',
      'searchInvoice',
      'searchAllInvoice',
      'markAsSent',
      'sendEmail',
      'deleteInvoice',
      'selectInvoice',
      'fetchViewInvoice'
    ]),
    async loadInvoices () {
      let adminData = {
        pre_pay: '1'
      }
      let funderData = {
        pre_pay: '1',
        status: 'AUTHORIZED'
      }
      let response
      if (this.userType == 'super_admin') {
        response = await this.fetchInvoices(adminData)
      } else if (this.userType == 'funder') {
        response = await this.fetchInvoices(funderData)
      } else {
        response = await this.fetchInvoices()
      }
      if (response.data) {
        this.invoices = response.data.invoices.data
      }
    },
    async loadInvoice () {
      let response = await this.fetchViewInvoice(this.$route.params.id)

      if (response.data) {
        this.invoice = response.data.invoice
      }
    },
    async onSearch () {
      let data = ''
      if (this.userType == 'super_admin') {
        data += `pre_pay=1&`
      } else if (this.userType == 'funder') {
        data += `pre_pay=1&status=SENT`
      }

      if (this.searchData.searchText !== '' && this.searchData.searchText !== null && this.searchData.searchText !== undefined) {
        data += `search=${this.searchData.searchText}&`
      }

      if (this.searchData.orderBy !== null && this.searchData.orderBy !== undefined) {
        data += `orderBy=${this.searchData.orderBy}&`
      }

      if (this.searchData.orderByField !== null && this.searchData.orderByField !== undefined) {
        data += `orderByField=${this.searchData.orderByField}`
      }

      this.isSearching = true

      let response = await this.searchInvoice(data)
      if (response.data) {
        this.invoices = response.data.invoices.data
      }

      this.isSearching = false
    },
    sortData () {
      if (this.searchData.orderBy === 'asc') {
        this.searchData.orderBy = 'desc'
        this.onSearch()
        return true
      }
      this.searchData.orderBy = 'asc'
      this.onSearch()
      return true
    },
    async onSendInvoice () {
      if (this.invoice.media.length > 0) {
        window.swal({
          title: this.$tc('general.are_you_sure'),
          text: this.$tc('invoices.confirm_send_invoice'),
          icon: '/assets/icon/paper-plane-solid.svg',
          buttons: true,
          dangerMode: true
        }).then(async (value) => {
          if (value) {
            this.isSendingEmail = true
            let response = await this.sendEmail({invoice_id: this.invoice.id})
            this.isSendingEmail = false
            if (response.data.success) {
              window.toastr['success'](this.$tc('invoices.send_invoice_successfully'))
              if (this.invoice.pre_pay == 1) {
                this.showPrePaymentRequestPopup(this.invoice.id)
              } else {
                this.$router.push(`/supplier/invoices`)
              }
              return true
            }
            if (response.data.error === 'user_email_does_not_exist') {
              window.toastr['error'](this.$tc('invoices.user_email_does_not_exist'))
              return false
            }
            window.toastr['error'](this.$tc('invoices.something_went_wrong'))
          }
        })
      } else {
        window.swal({
          title: this.$t('general.attach_documents'),
          text: this.$t('invoices.without_attachments_you_cant_sent'),
          icon: '/assets/icon/file-alt-solid.svg',
          buttons: true,
          dangerMode: true,
          buttons: {
            buttonOne: {
              text: 'Continue Anyway',
              value: 'continue_anyway',
              visible: true,
              className: 'swal-button--cancel',
              closeModal: true
            },
            buttonTwo: {
              text: 'Go to Attachments',
              value: 'go_to_attachments',
              visible: true,
              className: 'swal-button--danger',
              closeModal: true
            }
          }
        }).then(async (goToAttachment) => {
          if (goToAttachment === 'go_to_attachments') {
            this.$router.push(`/supplier/invoices/${this.invoice.id}/attachment`)
          } else if (goToAttachment === 'continue_anyway') {
            this.isSendingEmail = true
            let response = await this.sendEmail({invoice_id: this.invoice.id})
            this.isSendingEmail = false

            if (response.data.success) {
              window.toastr['success'](this.$tc('invoices.send_invoice_successfully'))
              if (this.invoice.id.pre_pay == 1) {
                this.showPrePaymentRequestPopup(this.invoice.id)
              } else {
                this.$router.push(`/supplier/invoices`)
              }

              return true
            }
            if (response.data.error === 'user_email_does_not_exist') {
              window.toastr['error'](this.$tc('invoices.user_email_does_not_exist'))
              return false
            }
            window.toastr['error'](this.$tc('invoices.something_went_wrong'))
          }
        })
      }
    },
    async showPrePaymentRequestPopup (id) {
      swal({
        title: this.$t('invoices.request_apply_for_PrePayment'),
        text: this.$t('invoices.do_you_want_to_apply_for_prepayment_request'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          this.prepaymentRequest(id)
        }
      })
    },
    async prepaymentRequest (id) {
      this.$router.push(`/supplier/prepayments/${id}/request`)
    },
    async removeInvoice (id) {
      this.selectInvoice([parseInt(id)])
      this.id = id
      window.swal({
        title: 'Deleted',
        text: 'you will not be able to recover this invoice!',
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          let request = await this.deleteInvoice(this.id)
          if (request.data.success) {
            window.toastr['success'](this.$tc('invoices.deleted_message', 1))
            this.$router.push('/supplier/invoices')
          } else if (request.data.error) {
            window.toastr['error'](request.data.message)
          }
        }
      })
    },
    nomailAmount (row) {
      let subTotal = row.sub_total
      let nomailAmount = 0
      let taxes = null
      if (row.taxes) {
        taxes = row.taxes.filter(function (obj) {
          return obj.operator !== 'Subtract'
        })
        if (taxes.length > 0) {
          nomailAmount = subTotal + taxes.map(o => o.amount).reduce((a, c) => { return a + c })
        } else {
          nomailAmount = row.sub_total
        }
      }
      return nomailAmount
    },
    viewInvoice (id) {
      if (this.userType == 'super_admin') {
        this.$router.push(`/super-admin/invoices/${id}/view`)
      } else if (this.userType == 'anchor') {
        this.$router.push(`/anchor/invoices/${id}/view`)
      } else if (this.userType == 'supplier') {
        this.$router.push(`/supplier/invoices/${id}/view`)
      } else if (this.userType == 'funder') {
        this.$router.push(`/funder/invoices/${id}/view`)
      }
    }
  }
}
</script>
